import apiCall from "../../axios";
import queryString from "query-string";

const unlock = async (opts: any = null) => {
  try {
    const stringified = queryString.stringify(opts);
    let tail = `operator/unlock`;
    if (opts) tail += `?${stringified}`;
    const res = await apiCall("GET", tail);
    return res.data;
  } catch (e) {
    if (e) throw e;
    throw new Error("Unknown Error");
  }
};

export default unlock;
